import { useState } from 'react';
import { Button, Spinner } from '@blueprintjs/core';

import { getReportPdf } from '@f/components/pages/dashboard/reports/utils/getReportPdf';

interface PdfDownloadButtonProps {
  reportId: string;
  text?: string;
  disabled?: boolean;
  large?: boolean;
}

export function PdfDownloadButton({ reportId, text, disabled, large }: PdfDownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPdf = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDownloading(true);
    await getReportPdf(reportId);
    setIsDownloading(false);
  };

  return (
    <Button
      large={large}
      minimal
      disabled={disabled || isDownloading}
      text={text}
      icon={isDownloading ? <Spinner size={16} /> : 'download'}
      onClick={downloadPdf}
      style={{ width: text ? 'auto' : '2rem' }}
      data-cy="button-report-download"
    />
  );
}
